<template>
  <div>
    <router-view></router-view>
    <web-socket-notification></web-socket-notification>
  </div>
</template>

<script>
import WebSocketNotification from "./components/Common/WebSocketNotification.vue";

export default {
  components: {
    WebSocketNotification,
  },
};
</script>
